<div class="messages-header-wrapper flex justify-between items-center">
  @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_LIST) {
    <div class="">
      <app-simple-button size="large" (click)="openCreateDiscussion()">New Message</app-simple-button>
    </div>
  }
  @if (
    (selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_VIEW ||
    (selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_CREATE
  ) {
    <div (click)="goBack()" class="flex items-center cursor-pointer">
      <app-back-button-box class="text-navy-600 font-semibold">Discussions</app-back-button-box>
    </div>
  }

  @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_THREAD_VIEW) {
    <div (click)="goBack(MESSAGING_VIEWS.DISCUSSION_VIEW)" class="flex items-center cursor-pointer">
      <app-back-button-box class="text-navy-600 font-semibold">{{
        (selectedGroup$ | async)?.name
      }}</app-back-button-box>
    </div>
  }
  <div class="flex items-center gap-3">
    <app-dropdown
      class="mt-0 mb-0"
      [ngModel]="defaultDiscussionType"
      (ngModelChange)="onTypeFilterChange($event)"
      [ngModelOptions]="{ standalone: true }"
      [options]="discussionTypeList"
      optionLabel="text"
      optionValue="type"
    >
    </app-dropdown>
    <app-search-input
      [verticalSpacing]="false"
      placeholder="Search Discussions..."
      label="Search Discussions..."
      (searchText)="onTextFilterChange($event)"
      inputClass="w-[200px]"
    ></app-search-input>
  </div>
</div>
